/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface PhonePost
 */
export interface PhonePost {
  /**
   * Consent. e.g. 'implied', 'consent', 'written_consent', 'revoked'
   * @type {string}
   * @memberof PhonePost
   */
  consent?: PhonePostConsentEnum;
  /**
   * If set, do-not-call is temporarily set until this time, and then unset
   * @type {Date | null}
   * @memberof PhonePost
   */
  dateDncExpires?: Date | null;
  /**
   * The date when the user asked for do-not-call
   * @type {Date | null}
   * @memberof PhonePost
   */
  dateDncOptOut?: Date | null;
  /**
   * If set, do-not-text is temporarily set until this time, and then unset
   * @type {Date | null}
   * @memberof PhonePost
   */
  dateDntExpires?: Date | null;
  /**
   * The date when the user asked for do-not-text
   * @type {Date | null}
   * @memberof PhonePost
   */
  dateDntOptOut?: Date | null;
  /**
   * Do-not-call boolean, permanent or temporary
   * @type {boolean}
   * @memberof PhonePost
   */
  dnc?: boolean;
  /**
   * DNC scope. e.g. 'powerdialer', 'ever', default is 'powerdialer'
   * @type {string}
   * @memberof PhonePost
   */
  dncScope?: PhonePostDncScopeEnum;
  /**
   * Do-not-text boolean, permanent or temporary
   * @type {boolean}
   * @memberof PhonePost
   */
  dnt?: boolean;
  /**
   * DNT scope. e.g. 'powerdialer', 'ever', default is 'powerdialer'
   * @type {string}
   * @memberof PhonePost
   */
  dntScope?: PhonePostDntScopeEnum;
  /**
   * e164 number to create
   * @type {string}
   * @memberof PhonePost
   */
  e164?: string;
  /**
   * Phone label. e.g. 'mobile', 'work', 'home', 'other'
   * @type {string}
   * @memberof PhonePost
   */
  label?: PhonePostLabelEnum;
  /**
   * Arbitrary tags we want to categorize the phone by
   * @type {Array<any>}
   * @memberof PhonePost
   */
  tags?: Array<any>;
  /**
   * Number validity. e.g. 'good', 'unverified', 'fax', spam'
   * @type {string}
   * @memberof PhonePost
   */
  validity?: PhonePostValidityEnum;
}

/**
 * @export
 */
export const PhonePostConsentEnum = {
  Implied: 'implied',
  Consent: 'consent',
  WrittenConsent: 'written_consent',
  Revoked: 'revoked',
} as const;
export type PhonePostConsentEnum =
  (typeof PhonePostConsentEnum)[keyof typeof PhonePostConsentEnum];

/**
 * @export
 */
export const PhonePostDncScopeEnum = {
  Powerdialer: 'powerdialer',
  Ever: 'ever',
} as const;
export type PhonePostDncScopeEnum =
  (typeof PhonePostDncScopeEnum)[keyof typeof PhonePostDncScopeEnum];

/**
 * @export
 */
export const PhonePostDntScopeEnum = {
  Powerdialer: 'powerdialer',
  Ever: 'ever',
} as const;
export type PhonePostDntScopeEnum =
  (typeof PhonePostDntScopeEnum)[keyof typeof PhonePostDntScopeEnum];

/**
 * @export
 */
export const PhonePostLabelEnum = {
  Mobile: 'mobile',
  Work: 'work',
  Home: 'home',
  Other: 'other',
} as const;
export type PhonePostLabelEnum =
  (typeof PhonePostLabelEnum)[keyof typeof PhonePostLabelEnum];

/**
 * @export
 */
export const PhonePostValidityEnum = {
  Good: 'good',
  Unverified: 'unverified',
  Disconnected: 'disconnected',
  Fax: 'fax',
  Spam: 'spam',
} as const;
export type PhonePostValidityEnum =
  (typeof PhonePostValidityEnum)[keyof typeof PhonePostValidityEnum];

/**
 * Check if a given object implements the PhonePost interface.
 */
export function instanceOfPhonePost(value: object): value is PhonePost {
  return true;
}

export function PhonePostFromJSON(json: any): PhonePost {
  return PhonePostFromJSONTyped(json, false);
}

export function PhonePostFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PhonePost {
  if (json == null) {
    return json;
  }
  return {
    consent: json['consent'] == null ? undefined : json['consent'],
    dateDncExpires:
      json['date_dnc_expires'] == null
        ? undefined
        : new Date(json['date_dnc_expires']),
    dateDncOptOut:
      json['date_dnc_opt_out'] == null
        ? undefined
        : new Date(json['date_dnc_opt_out']),
    dateDntExpires:
      json['date_dnt_expires'] == null
        ? undefined
        : new Date(json['date_dnt_expires']),
    dateDntOptOut:
      json['date_dnt_opt_out'] == null
        ? undefined
        : new Date(json['date_dnt_opt_out']),
    dnc: json['dnc'] == null ? undefined : json['dnc'],
    dncScope: json['dnc_scope'] == null ? undefined : json['dnc_scope'],
    dnt: json['dnt'] == null ? undefined : json['dnt'],
    dntScope: json['dnt_scope'] == null ? undefined : json['dnt_scope'],
    e164: json['e164'] == null ? undefined : json['e164'],
    label: json['label'] == null ? undefined : json['label'],
    tags: json['tags'] == null ? undefined : json['tags'],
    validity: json['validity'] == null ? undefined : json['validity'],
  };
}

export function PhonePostToJSON(value?: PhonePost | null): any {
  if (value == null) {
    return value;
  }
  return {
    consent: value['consent'],
    date_dnc_expires:
      value['dateDncExpires'] == null
        ? value['dateDncExpires']
        : (value['dateDncExpires'] as any).toISOString(),
    date_dnc_opt_out:
      value['dateDncOptOut'] == null
        ? value['dateDncOptOut']
        : (value['dateDncOptOut'] as any).toISOString(),
    date_dnt_expires:
      value['dateDntExpires'] == null
        ? value['dateDntExpires']
        : (value['dateDntExpires'] as any).toISOString(),
    date_dnt_opt_out:
      value['dateDntOptOut'] == null
        ? value['dateDntOptOut']
        : (value['dateDntOptOut'] as any).toISOString(),
    dnc: value['dnc'],
    dnc_scope: value['dncScope'],
    dnt: value['dnt'],
    dnt_scope: value['dntScope'],
    e164: value['e164'],
    label: value['label'],
    tags: value['tags'],
    validity: value['validity'],
  };
}
